import type WebSocket from 'ws';
import type { CliPromptTurnState } from '@buildautomaton/types';
import { sendWsMessage } from '../connection/create-ws-bridge.js';

export function sendPromptQueueClientReport(
  ws: WebSocket | null,
  queues: Record<string, Array<{ turnId: string; cliState: CliPromptTurnState | null }>>,
): boolean {
  if (!ws) return false;
  const wireQueues: Record<string, Array<{ turnId: string; clientState: CliPromptTurnState | null }>> = {};
  for (const [queueKey, rows] of Object.entries(queues)) {
    wireQueues[queueKey] = rows.map((r) => ({ turnId: r.turnId, clientState: r.cliState }));
  }
  sendWsMessage(ws, { type: 'prompt_queue_client_report', queues: wireQueues });
  return true;
}
